<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: laikt
 * @Date: 2020-11-11 10:27:36
 * @LastEditors: laikt
 * @LastEditTime: 2020-12-02 14:24:37
-->
<template>
  <div class="temperature">
    <div class="temperature_header">
      <span class="temperature_header_title">
        温度回放
      </span>
      <div class="temperature_header_check">
        <span class="temperature_header_label">选择摄像头</span>
        <slot></slot>
        <el-button
          class="async_auto"
          type="primary"
          size="small"
          @click="syncHandler"
          :loading="syncIsDisabled"
          :disabled="syncIsDisabled"
        >
          {{ videoMapStatus == 0 ? "开始播放" : "停止播放" }}
        </el-button>
      </div>
    </div>
    <div class="temperature_content">
      <div class="charts" ref="charts"></div>
      <div class="time-line-wrapper">
        <lo-slider-time
          ref="sliderTime"
          class="time-line"
          :show-tooltip="true"
          :format-tooltip="formatTooltip"
          @change="sliderChange"
          v-model="timeLineRange"
        >
          <div class="video-range">
            <el-tooltip
              placement="top"
              v-for="(item, index) in currentAllLineVideos"
              :key="index"
            >
              <div slot="content">
                监测点状态：
                <span
                  :class="item.className"
                  style="
                    display:inline-block;width: 10px;
                    height: 10px;
                    border-radius: 2px;"
                ></span>
                <span>
                  {{ monitStatus[item.monitStatus] }}
                </span>
                <br />
                开始时间：{{
                  moment(item.startTime).format("YYYY-MM-DD HH:mm:ss")
                }}
                <br />
                结束时间：{{
                  moment(item.endTime).format("YYYY-MM-DD HH:mm:ss")
                }}
              </div>
              <div
                class="video-item"
                :style="tempItemStyle(item)"
                :class="item.className"
              ></div>
            </el-tooltip>
          </div>
        </lo-slider-time>
      </div>
    </div>
  </div>
</template>
<script>
import LoSliderTime from "@/components/video/LoSliderTime";
import api from "@/api/monitorCenter/warehouseVideo.js";
import moment from "moment";
import echarts from "echarts";

export default {
  name: "temperature",
  components: {
    LoSliderTime
  },
  props: {
    cameraId: {
      type: Number
    },
    videoMapStatus: {
      type: Number,
      default: 0
    },
    time: String,
    timeList: {
      type: Array,
      default: () => []
    },
    cameraList: {
      type: Array,
      default: () => []
    },
    checkedNode: {
      type: Object,
      default: () => {}
    },
    syncIsDisabled: {
      type: Boolean,
      default: () => {}
    }
  },
  computed: {
    currentAllLineVideos() {
      // const data = [];
      console.log("this.timeListthis.timeList", this.timeList);
      // this.timeList.forEach((value, index) => {
      //   console.log(
      //     value.startTime === this.startTime,
      //     value.startTime > this.startTime && value.endTime !== this.endTime
      //   );
      //   if (value.startTime === this.startTime) {
      //     data.push(value);
      //   }
      //   if (index === 0) {
      //     if (
      //       value.startTime > this.startTime &&
      //       value.endTime !== this.endTime
      //     ) {
      //       data.push({
      //         startTime: this.startTime,
      //         endTime: value.startTime - 1,
      //         monitStatus: 1,
      //         className: "success"
      //       });
      //       data.push(value);
      //     }
      //   } else {
      //     if (
      //       value.startTime > data[index - 1].startTime &&
      //       value.endTime !== this.endTime
      //     ) {
      //       data.push({
      //         startTime: this.startTime,
      //         endTime: value.startTime - 1,
      //         monitStatus: 1,
      //         className: "success"
      //       });
      //       data.push(value);
      //     }
      //   }

      //   if (
      //     index + 1 === this.timeList.length &&
      //     value.endTime < this.endTime
      //   ) {
      //     data.push({
      //       startTime: value.endTime + 1,
      //       monitStatus: 1,
      //       endTime: this.endTime,
      //       className: "success"
      //     });
      //   }
      // });
      // console.log("t.data", data);

      return this.timeList;
    },
    startTime() {
      return moment(this.time)
        .startOf("day")
        .valueOf();
    },
    endTime() {
      return moment(this.time)
        .endOf("day")
        .valueOf();
    }
  },
  data() {
    return {
      moment,
      radio: "",
      charts: null,
      monitStatus: {
        "0": "",
        "1": "正常温度",
        "2": "温度预警",
        "3": "温度报警",
        "4": "温度掉线",
        "5": "脱温"
      },
      indexFormat: {
        "0": "",
        "1": 1,
        "2": 2,
        "3": 4,
        "4": 5,
        "5": 3
      },
      // currentAllLineVideos: [],
      // 温湿度曲线
      storageHumiture: [],
      // currentAllLineVideos: [],
      timeLineRange: 0 // 时间轴范围
    };
  },
  mounted() {
    // this.currentAllLineVideos = data;
    this.$nextTick(() => {
      console.log(this.checkedNode, this.time);
      // this.queryStorageHumitureDetails();
    });
    // window.addEventListener("resize", () => {
    //   this.charts.resize();
    // });
  },
  methods: {
    syncHandler() {
      // this.cameraList.findIndex(e => e.cameraId === this.cameraId);
      this.$emit("queryTemVideo", this.timeLineRange);
    },
    sliderChange(value) {
      this.$emit(
        "sliderChange",
        value,
        this.cameraList.find(e => (e.cameraId = this.cameraId)),
        0
      );
    },
    // 获取温湿度曲线
    queryStorageHumitureDetails() {
      api
        .queryStorageHumitureDetails({
          pointId: this.checkedNode.id,
          intervalTime: 0,
          pageParamVO: {
            curPage: 1,
            pageSize: 20,
            sortDir: "ASC",
            sortIndx: "ModifiedTime"
          },
          beginTime: moment(this.time)
            .startOf("day")
            .valueOf(),
          endTime: moment(this.time)
            .endOf("day")
            .valueOf()
        })
        .then(res => {
          if (res && res.code === 1 && res.result) {
            this.storageHumiture = res.result.chartData;
            this.storageHumitureCharts();
          }
        });
    },
    // 格式化提示时间
    formatTooltip(value) {
      let time = moment()
        .startOf("days")
        .valueOf();

      return moment(time + value).format("HH:mm:ss");
    },
    // 设置每个时间块的样式
    tempItemStyle(data) {
      let max = 86400000;
      let today = this.startTime;
      // let bTime = moment(data.startTime).valueOf();
      // let eTime = moment(data.endTime).valueOf();
      let bTime = moment(data.startTime).valueOf();
      let eTime = moment(data.endTime).valueOf();
      return {
        left: ((bTime - today) / max) * 100 + "%",
        width: ((eTime - bTime) / max) * 100 + "%",
        zIndex: this.indexFormat[data.monitStatus]
        // left: 10 * 100 + "%",
        // width: 20 + "%"
      };
    },
    storageHumitureCharts() {
      const xData = [];
      const chartData = {
        tem1: {
          title: "1路",
          data: [],
          chart: {
            name: "1路",
            type: "line",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#1CAC4B"
                  },
                  {
                    offset: 1,
                    color: "#76E8A9"
                  }
                ])
              }
            },
            data: [],
            zlevel: 1
          }
        },
        tem2: {
          title: "2路",
          data: [],
          chart: {
            name: "2路",
            type: "line",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#4466F4"
                  },
                  {
                    offset: 1,
                    color: "#46A1FD"
                  }
                ])
              }
            }
          }
        },
        tem3: {
          title: "3路",
          data: [],
          chart: {
            name: "3路",
            type: "line",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#ff7802"
                  },
                  {
                    offset: 1,
                    color: "#e6a045"
                  }
                ])
              }
            }
          }
        }
      };

      this.storageHumiture.forEach(e => {
        // X坐标轴
        !xData.includes(e.time) && xData.push(e.time);
        // 1路
        e.tem1 &&
          chartData.tem1.data.push(e.tem1 !== -999 ? Number(e.tem1) : "");
        // 2路
        e.tem2 &&
          chartData.tem2.data.push(e.tem2 !== -999 ? Number(e.tem2) : "");
        // 3路
        e.tem3 &&
          chartData.tem3.data.push(e.tem3 !== -999 ? Number(e.tem3) : "");
      });
      this.charts = echarts.init(this.$refs.charts);
      const legendData = [];
      const series = [];
      for (const key in chartData) {
        if (chartData.hasOwnProperty(key)) {
          const element = chartData[key];
          if (element.data.length > 0) {
            legendData.push(element.title);
            element.chart.data = element.data;
            series.push(element.chart);
          }
        }
      }
      var option = {
        title: {
          top: 20,
          left: 10
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          show: true,
          itemWidth: 16,
          itemHeight: 3,
          itemGap: 12,
          borderRadius: 5,
          top: 10,
          right: 60,
          data: legendData,
          icon: "roundRect",
          textStyle: {
            color: "#4e5979"
          }
        },
        grid: {
          left: 40,
          right: 60,
          bottom: 0,
          top: 40,
          containLabel: true,
          z: 1
        },
        xAxis: {
          type: "category",
          data: xData,
          showAllSymbol: false,
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            onZero: false,
            lineStyle: {
              color: "#4e5979"
            }
          },
          axisLabel: {
            show: true,
            color: "#4e5979",
            fontSize: 12
          }
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          },
          name: "温度(℃)",
          nameTextStyle: {
            color: "#4e5979",
            align: "right",
            padding: [0, 0, 0, 0]
          },
          splitArea: {
            show: true,
            areaStyle: {
              color: ["transparent", "rgba(24, 137, 253, 0.1)"]
            }
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#4e5979"
            }
          },
          axisLabel: {
            color: "#4e5979"
          }
        },
        series: series
      };
      this.charts.setOption(option);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/videoCommon.scss";
@import "@/assets/styles/videoMonit.scss";
$normalfont: #9297a6;
$sidebarwidth: 240px;
$lightfont: #46bfea;
.temperature {
  &_header {
    height: 40px;
    width: 100%;
    border-bottom: 1px solid #153771;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 14px;
    box-sizing: border-box;
    .temperature_header_label {
      display: inline-block;
      margin-right: 14px;
    }
    /deep/.el-radio__inner {
      background-color: #153771;
    }
    /deep/.el-radio__input.is-checked .el-radio__inner {
      background-color: #46bfea;
    }
  }
  &_content {
    padding: 14px;
    box-sizing: border-box;
  }
  .time-line-wrapper {
    position: relative;
    padding: 30px 60px 0;
    box-sizing: border-box;
    /deep/ .lo-slider-time {
      background-color: #08193b;
      /deep/ .el-slider__runway {
        background-color: #21304d;
        border-color: #2d3e64;
        border-width: 1px;
        border-radius: unset;
      }
      /deep/ .el-slider__footer {
        background-color: #08193b;
        .time-item {
          color: $normalfont;
          &::before {
            background-color: #2e3e63;
          }
        }
      }
      .el-slider__button-wrapper {
        width: 9px;
        background-color: unset;
        .tooltip {
          color: $lightfont;
        }
        .tooltip-btn {
          background-color: unset;
        }
      }
      .el-slider__bar-right {
        background-color: transparent;
        display: none;
      }
      .tooltip-left {
        background: none;
        background-repeat: no-repeat;
        background-size: contain;
        background-color: #3facd2;
        width: 3px;
      }
      .tooltip-right {
        background: url("../../../assets/images/video/right.png");
        background-repeat: no-repeat;
        background-size: contain;
      }
    }
  }
  .lo-slider-time /deep/.el-slider__runway {
    height: 20px;
  }
  .el-slider.el-slider-reset {
    height: 30px !important;
  }
  .el-slider {
    height: 40px !important;
  }
  .charts {
    width: 100%;
    height: 180px;
  }
  .video-range {
    position: relative;
    height: 100%;
    .video-item {
      position: absolute;
      top: 0;
      height: 100%;
      background-color: #ffaa00;
      border-radius: 5px;
      .el-tooltip {
        width: 100%;
        display: inline-block;
        opacity: 0;
      }
    }
    .success {
      background: #67c23a;
    }
    .warn {
      background: #e39726;
    }
    .error {
      background: #f45a5a;
    }
    // 掉线
    .off {
      background: #9b9ea3;
    }
    // 脱温
    .deheat {
      background: #ea6fc3;
    }
  }
  .el-button {
    background-color: #164271;
    color: #46bfea;
    border-color: #46bfea;
  }
  .async_auto {
    margin-left: 20px;
  }
}
</style>
<style lang="scss">
.el-tooltip__popper {
  .success {
    background: #67c23a;
  }
  .warn {
    background: #e39726;
  }
  .error {
    background: #f45a5a;
  }
  // 掉线
  .off {
    background: #9b9ea3;
  }
  // 脱温
  .deheat {
    background: #ea6fc3;
  }
}
</style>
